import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import SaveIcon from '@material-ui/icons/Save';
import LabelSelector from './LabelSelector';

const useStyles = makeStyles({
  button: {
    backgroundColor: '#2ca0f7',
    color: 'white',
    height: '55px',
    textTransform: 'none',
    fontFamily: 'Exo 2',
  },
  counterContainer: {
    minWidth: '13vw',
  },
  resetButton: {
    textTransform: 'none',
  },
  counter: {
    fontSize: '60px',
  },
});

const ActionPanel = ({
  items,
  predictions,
  makePredictions,
  setLabel,
  labelPredictions,
  labels,
  loadingPredictions,
  loadingLabeling,
  count,
  resetCount,
  multiLabel,
}) => {
  const classes = useStyles();
  const onCaptureAll = (event) => {
    event.preventDefault();
    makePredictions();
  };
  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item>
        {[...Array(multiLabel).keys()].map((i) => (
          <LabelSelector
            key={`label-selector-${i}`} // eslint-disable-line react/no-array-index-key
            label={labels[i]}
            setLabel={setLabel}
            items={items}
            index={i}
          />
        ))}
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          disableElevation
          className={classes.button}
          disabled={loadingPredictions}
          endIcon={<PhotoCamera />}
          onClick={onCaptureAll}
        >
          Capture All (shift)
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          disableElevation
          className={classes.button}
          disabled={loadingLabeling}
          endIcon={<SaveIcon />}
          onClick={() => labelPredictions(labels, predictions)}
        >
          Save All (space)
        </Button>
      </Grid>
      <Grid item className={classes.counterContainer}>
        <Grid container direction="column" alignItems="center">
          <Grid className={classes.counter}>{count}</Grid>
          <Button
            color="primary"
            className={classes.resetButton}
            disableElevation
            onClick={resetCount}
          >
            Reset
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(ActionPanel);
